export default (v: null | boolean) => !!v || "Field is required"
